import ENDPOINT from 'constants/endPoint';
import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

const socialOrganizationFeedbackApi = {
  async getSocialOrganizationFeedbacks(payload = {}) {
    const params = getParamsFormObject(payload);
    const path = ENDPOINT.SOCIAL_ORGANIZATION_FEEDBACKS + params;

    const response = await axiosClient.get(path);
    return response.data;
  },

  async getSocialOrganizationFeedbackDetail(id) {
    const path = ENDPOINT.SOCIAL_ORGANIZATION_FEEDBACK_DETAIL(id);

    const response = await axiosClient.get(path);
    return response.data;
  },

  async updateSocialOrganizationFeedback(id, data = {}) {
    const path = ENDPOINT.SOCIAL_ORGANIZATION_FEEDBACK_DETAIL(id);

    const response = await axiosClient.put(path, {
      status: data.status,
      response: data.response || data.note || '',
    });
    return response.data;
  },

  async resolveSocialOrganizationFeedback(id, data = {}) {
    const path = ENDPOINT.SOCIAL_ORGANIZATION_FEEDBACK_DETAIL(id);

    const response = await axiosClient.put(path, {
      status: 'APPROVED',
      response: data.response || data.note || '',
    });
    return response.data;
  },

  async rejectSocialOrganizationFeedback(id, data = {}) {
    const path = ENDPOINT.SOCIAL_ORGANIZATION_FEEDBACK_DETAIL(id);

    const response = await axiosClient.put(path, {
      status: 'REJECTED',
      response: data.response || data.note || '',
    });
    return response.data;
  },
};

export default socialOrganizationFeedbackApi;
